module.exports = __webpack_public_path__ + "8439bc8245c99e381f8f8b2aa4a6935f.svg";